module.exports = __webpack_public_path__ + "static/img/environment_06.6d51bc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/environment_06.png
// module id = rmRK
// module chunks = 34